import { gql } from "@apollo/client";
import moment from "moment";
import { store } from "../../../redux/store";
import { fetchMutation } from "../../../actions";

export const GET_NOTES_DATA = gql`
   query GetNotes($notes: getNotes) {
      getNotes(Notes: $notes) {
         notes {
            id
            isDisable
            mediaId
            status
            title
            patientName
            encounterName
            dob
            gender
            mrn
            createdAt
            notes
            isRead
            templateId
            diarization
            contentLength
            ehrSendStatus
            isPatientLinkedToNote
            template {
               title
            }
         }
         totalCount
      }
   }
`;
export const CREATE_NOTES = gql`
   mutation Mutation($createNotes: createNotes) {
      createNotes(createNotes: $createNotes) {
         status {
            code
            message
            success
         }
         notes {
            id
            notes
            templateTitle
            title
         }
         media {
            signUrl
         }
      }
   }
`;

export const CREATE_NOTES_V2 = gql`
   mutation CreateNotesV2($createNotesV2: createNotes) {
      createNotesV2(createNotesV2: $createNotesV2) {
         notes {
            id
         }
         status {
            code
            message
         }
      }
   }
`;

export const CREATE_TEMPLATE = gql`
   mutation UpsertNotesTemplate($notesTemplate: NoteTemplateInput) {
      upsertNotesTemplate(notesTemplate: $notesTemplate) {
         status {
            code
            success
            message
         }
         template {
            id
            title
         }
      }
   }
`;
export const DELETE_CREATE_NOTES = gql`
   mutation Mutation($createNotes: createNotes) {
      createNotes(createNotes: $createNotes) {
         status {
            code
            success
            message
         }
      }
   }
`;

export const GET_SIGNED_URL_V2 = gql`
   query Query($noteId: String, $fileName: String) {
      getCreateNotesSignedUrl(noteId: $noteId, fileName: $fileName) {
         signedUrl
         status {
            code
            message
         }
      }
   }
`;

export const GET_NOTES_TEMPLATES_DATA = gql`
   query GetNotesTemplate($notesTemplate: getNotesTemplate) {
      getNotesTemplate(notesTemplate: $notesTemplate) {
         totalCount
         template {
            id
            providerId
            enterpriseId
            hospitalId
            isDisable
            title
            default
            shortDescription
            description
            documentId
            alreadyExists
            isSampleAvailable
            sample
            isCustom
            createdAt
         }
      }
   }
`;

export const GET_NOTES_TEMPLATES_DATA_V2 = gql`
   query getNotesTemplateV2($notesTemplate: getNotesTemplateV2) {
      getNotesTemplateV2(notesTemplate: $notesTemplate) {
         totalCount
         currentPage
         totalPages
         template {
            id
            providerId
            enterpriseId
            hospitalId
            isDisable
            title
            default
            shortDescription
            description
            documentId
            alreadyExists
            isSampleAvailable
            sample
         }
      }
   }
`;

export const UPDATE_NOTES = gql`
   mutation Mutation($notesTemplate: NoteTemplateInput) {
      upsertNotesTemplate(notesTemplate: $notesTemplate) {
         status {
            code
            success
            message
         }
      }
   }
`;
export const GET_DICTATION_SIGNED_URL = gql`
   query GetSignedURL($thumbnail: Boolean!, $content: ContentInput, $includeDiarization: Boolean) {
      getSignedURL(thumbnail: $thumbnail, content: $content, includeDiarization: $includeDiarization) {
         Diarization
         thumbnailUrl
         url
         Transcription
         dataCount
      }
   }
`;

export const ADD_USER_FEEDBACK = gql`
   mutation Mutation(
      $noteId: String!
      $billingCodeFeedback: String
      $billingOrderFeedback: String
      $codeReviewFeedback: codeReviewFeedback
      $orderReviewFeedback: orderReviewFeedback
   ) {
      updateBillingCode(
         noteId: $noteId
         billingCodeFeedback: $billingCodeFeedback
         billingOrderFeedback: $billingOrderFeedback
         codeReviewFeedback: $codeReviewFeedback
         orderReviewFeedback: $orderReviewFeedback
      ) {
         message
      }
   }
`;

export const SUBMIT_TO_EHR = gql`
   mutation SendCodeToEHR($noteId: String!, $clinicalData: ClinicalCodeItemInput) {
      sendCodeToEHR(noteId: $noteId, clinicalData: $clinicalData) {
         message
         success
      }
   }
`;

export const getFormattedStampDateTime = (stampDate) => {
   const date = new Date(stampDate);
   let oneDate = moment(date);
   let dayName = oneDate.format("dddd");
   let diffInDays = Math.round(moment().diff(stampDate, "days", true));
   if (diffInDays === 0) {
      return (dayName = "Today  at " + moment(date).format("hh:mm A"));
   } else if (diffInDays === 1) {
      return (dayName = "Yesterday  at " + moment(date).format("hh:mm A"));
   } else {
      return moment(date).format("MM/DD/YYYY") + " at " + moment(date).format("hh:mm A");
   }
};

export const getFormattedNoteStampDateTime = (stampDate, sendTodayforTime = false) => {
   const date = new Date(stampDate);
   let oneDate = moment(date);
   let dayName = oneDate.format("dddd");
   let diffInDays = Math.round(moment().diff(stampDate, "days", true));

   if (diffInDays === 0) {
      return !sendTodayforTime ? moment(date).format("hh:mm A") : "Today"; // Time for today
   } else if (diffInDays === 1) {
      return "Yesterday"; // Label for yesterday
   } else if (diffInDays < 7) {
      return sendTodayforTime ? "Last 7 Days" : dayName; // Day of the week for the past week
   } else {
      return sendTodayforTime ? "Older" : moment(date).format("MM/DD/YYYY"); // Standard date format
   }
};
export const getEpicFormattedStampDateTime = (stampDate) => {
   const date = new Date(stampDate);
   let oneDate = moment(date);
   let dayName = oneDate.format("dddd");
   let diffInDays = Math.round(moment().diff(stampDate, "days", true));
   if (diffInDays === 0) {
      return (dayName = "Today  " + moment(date).format("hh:mm A"));
   } else if (diffInDays === 1) {
      return (dayName = "Yesterday  " + moment(date).format("hh:mm A"));
   } else {
      return moment(date).format("MM/DD/YYYY") + " " + moment(date).format("hh:mm A");
   }
};
export const convertDecimalToTime = (decimal) => {
   const totalSeconds = Math.floor(decimal * 60);
   const hours = Math.floor(totalSeconds / 3600);
   const minutes = Math.floor((totalSeconds % 3600) / 60);
   const seconds = totalSeconds % 60;

   return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
};

export const sendDataDogLogs = (customEvent = false, errorObj = null) => {
   const userId = store.getState()?.auth?.loggedInProviderDetails?.id;
   const noteID = localStorage.getItem("noteIdCurrent");
   let eventName = "notes_recording-" + noteID + "-" + userId;
   if (customEvent) {
      eventName = customEvent + "-" + noteID + "-" + userId;
   }
   let errorObjString = null;
   try {
      errorObjString = errorObj ? JSON.stringify(errorObj) : null;
   }
   catch (err) {
      errorObjString = errorObj?.message || String(errorObj);
   }

   if (window.DD_RUM && userId) {
      window.DD_RUM.addAction(eventName, {
         noteId: noteID,
         "browser-agent": navigator.userAgent,
         providerId: userId,
         errorObj: errorObjString
      });
   }
};
export const UpdatesNoteStatus = (noteId) => {
   let notesObj = {
      createNotesV2: {
         status: "pending",
         id: noteId,
      },
   };
   fetchMutation(CREATE_NOTES_V2, notesObj);
};

const UPLOAD_MAX_RETRIES = 2;
const RETRYABLE_STATUS_CODES = [408, 425, 429, 500, 502, 503, 504];
const BASE_RETRY_DELAY_MS = 500;

const sleep = (ms) =>
   new Promise((resolve) => {
      setTimeout(resolve, ms);
   });

const getNetworkErrorMessage = (error) => {
   if (!error) return "";
   const errorMessage = error?.message || String(error);
   return errorMessage.toUpperCase();
};

const isRetryableNetworkError = (error) => {
   const errorMessage = getNetworkErrorMessage(error);
   return (
      errorMessage.includes("ERR_NAME_NOT_RESOLVED") ||
      errorMessage.includes("ERR_NETWORK_CHANGED") ||
      errorMessage.includes("ERR_CONNECTION_RESET") ||
      errorMessage.includes("FAILED TO FETCH")
   );
};

const getErrorMessage = (error) => error?.message || String(error);

const getBackoffDelay = (attempt) => {
   const exponentialDelay = BASE_RETRY_DELAY_MS * 2 ** attempt;
   const jitter = Math.floor(Math.random() * 200);
   return exponentialDelay + jitter;
};

const buildUploadError = (status, bodyText = "") => {
   const normalizedBody = (bodyText || "").replace(/\s+/g, " ").trim().slice(0, 400);
   const bodySuffix = normalizedBody ? ` - ${normalizedBody}` : "";
   return new Error(`Upload failed with status ${status}${bodySuffix}`);
};

export async function uploadmedia(url, file, getFreshSignedUrl = null) {
   let currentUrl = url;
   let lastError = null;

   for (let attempt = 0; attempt <= UPLOAD_MAX_RETRIES; attempt++) {
      try {
         const response = await fetch(currentUrl, {
            method: "PUT",
            body: file,
            headers: {
               "Content-Type": file.type || "application/octet-stream",
            },
            keepalive: false,
            cache: "no-store",
            credentials: "omit",
         });

         if (response.ok) {
            return;
         }

         const shouldRetryStatus = RETRYABLE_STATUS_CODES.includes(response.status);
         const isLastAttempt = attempt === UPLOAD_MAX_RETRIES;
         let responseBody = "";
         try {
            responseBody = await response.text();
         } catch (err) {
            responseBody = "";
         }

         sendDataDogLogs("recording-upload-http-error", {
            status: response.status,
            attempt: attempt + 1,
            browserOnline: typeof navigator !== "undefined" ? navigator.onLine : null,
            body: (responseBody || "").slice(0, 400),
         });

         const uploadStatusError = buildUploadError(response.status, responseBody);
         if (!shouldRetryStatus || isLastAttempt) {
            throw uploadStatusError;
         }

         lastError = uploadStatusError;
      } catch (error) {
         const isLastAttempt = attempt === UPLOAD_MAX_RETRIES;
         const retryableNetworkError = isRetryableNetworkError(error);
         const shouldRetry = retryableNetworkError && !isLastAttempt;

         const browserOnline = typeof navigator !== "undefined" ? navigator.onLine : null;
         sendDataDogLogs("recording-upload-network-error", {
            message: getErrorMessage(error),
            name: error?.name || "UnknownError",
            browserOnline,
            attempt: attempt + 1,
         });

         lastError = error;
         if (!shouldRetry) {
            throw error;
         }
      }

      if (typeof getFreshSignedUrl === "function") {
         try {
            const refreshedUrl = await getFreshSignedUrl();
            if (refreshedUrl) {
               currentUrl = refreshedUrl;
            }
            else {
               throw new Error("Signed URL refresh returned an empty value");
            }
         } catch (refreshError) {
            sendDataDogLogs("recording-upload-refresh-url-failed", {
               message: getErrorMessage(refreshError),
               name: refreshError?.name || "UnknownError",
            });
            throw refreshError;
         }
      }

      const retryDelayMs = getBackoffDelay(attempt);
      await sleep(retryDelayMs);
   }

   throw lastError || new Error("Upload failed");
}